import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { injectIntl, FormattedNumber } from 'react-intl';

import AbstractTimelineEvent from 'components/layout/embeddedTimeline/AbstractTimelineEvent';

import InvoiceDetails from 'components/modals/InvoiceDetails';

class TimelineMailNewInvoice extends AbstractTimelineEvent {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false,
    };
  }

  showDetails = () => {
    this.setState({ showDetails: true });
  };

  closeDetails = () => {
    this.setState({ showDetails: false });
  };

  render() {
    const {
      intl: { messages },
    } = this.props;
    const { showDetails } = this.state;

    return (
      <div class="card-block">
        <div style={{ position: 'absolute' }}>
          <i class="fa fa-file-text-o fa-2x" />
        </div>
        <div class="p-l-55">
          <Row>
            <Col xs={12}>
              <p>{messages.events.TimelineMailNewInvoice}</p>
            </Col>
          </Row>

          <Row>
            <Col xs={4}>{messages.salesDoc.invoice}</Col>
            <Col xs={8}>
              #{this.getDynParam('numberPrefix')}
              {this.getDynParam('number')}
            </Col>
          </Row>

          <Row>
            <Col xs={4}>{messages.salesDoc.total_due}</Col>
            <Col xs={8}>
              <FormattedNumber
                value={this.getDynParam('sumGross')}
                style="currency"
                currency={this.getDynParam('currency')}
              />
            </Col>
          </Row>

          <div class="p-b-5" />

          <Row>
            <Col xs={12}>
              <Button onClick={this.showDetails}>
                <i class="fa fa-angle-double-right" /> {messages.view}
              </Button>
            </Col>
          </Row>
        </div>

        <InvoiceDetails show={showDetails} close={this.closeDetails} invoiceId={this.getParam('invoiceId')} />
      </div>
    );
  }
}

export default injectIntl(TimelineMailNewInvoice);
